function obtenerStockLibreriaNacional(variantId) {
  
  return axios.get('https://cei31jbvfj.execute-api.us-east-1.amazonaws.com/prod/stock-by-locations-ln', {
    params: {
        variantId: `gid://shopify/ProductVariant/${variantId}`
      },
      headers: {
        'x-api-key': "1fbc9dff-b26c-4631-87fa-7c1540e66c04"
      }
  })
  .then(response => {
    const locations = response.data?.data?.productVariant?.inventoryItem?.inventoryLevels?.edges || [];
    
    const libreriaNacional = locations.find(edge => 
      edge.node.location.name === "CD Librería Nacional"
    );
    
    if (libreriaNacional) {
      const quantity = libreriaNacional.node.quantities[0]?.quantity || 0;
      return { hasStock: quantity > 0, quantity: quantity };
    }
    
    return { hasStock: false, quantity: 0 };
  })
  .catch(error => {
    console.error('Error al consultar stock:', error);
    return { hasStock: false, quantity: 0 };
  });
}